module.exports = __webpack_public_path__ + "img/payroll09.e7769277.jpeg";